$(document).ready(function() {
    if ($('body').data('router-name') !== 'to-translate-index') {
        return;
    }

    window.ajaxLoadRow.initialize(toTranslateUrl, 5, toTranslateExtendLockUrl);

    $(function() {
        var $content = $('[data-ajaxloadrow-rows-content]');
        $content.delegate('[data-human-translator-skip-action]', 'click', function(ev) {
            ev.preventDefault();
            var $shipAction = $(this);
            var $textareaContent = $shipAction.closest('.phrase-edit-textarea');
            var $noShipAction = $textareaContent.find('[data-human-translator-no-skip-action]');
            var $rowContent = $shipAction.closest('[data-ajaxloadrow-row]');
            var $textarea = $textareaContent.find('textarea');
            var $skipContent = $rowContent.find('[data-human-translator-skip-content]');
            $hidden = $('<input/>').prop('type', 'hidden').prop('name', $textarea.attr('name')).val('--skip--');
            $skipContent.append($hidden);
            $textareaContent.addClass('skip-this-text');
            $shipAction.hide();
            $noShipAction.show();
        });

        $content.delegate('[data-human-translator-no-skip-action]', 'click', function(ev) {
            var $noShipAction = $(this);
            var $textareaContent = $noShipAction.closest('.phrase-edit-textarea');
            var $shipAction = $textareaContent.find('[data-human-translator-skip-action]');
            var $rowContent = $noShipAction.closest('[data-ajaxloadrow-row]');
            var $skipContent = $rowContent.find('[data-human-translator-skip-content]');
            var $textarea = $textareaContent.find('textarea');

            $skipContent.find('input[name="' + $textarea.attr('name') + '"]').remove();
            $shipAction.show();
            $noShipAction.hide();
            $textareaContent.removeClass('skip-this-text');
        });
    });
});
